import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ExportsApiService {
  private readonly baseUrl = environment.bffBaseUrl;

  constructor(private http: HttpClient) {}

  downloadStudies(studyInstanceUids: string[]): Observable<HttpResponse<Blob>> {
    const body = { studyInstanceUids };

    return this.http.post(`${this.baseUrl}/exports/studies`, body, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
